export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14227.f91efb5d.jpg";